// extracted by mini-css-extract-plugin
module.exports = {"buttonToAnswerQuestion":"Es","disabled":"Fs","seeAllAnswers":"Gs"};